import _extends from 'babel-runtime/helpers/extends';
import _typeof from 'babel-runtime/helpers/typeof';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { polyfill } from 'react-lifecycles-compat';
import ContainerRender from './ContainerRender';
import Portal from './Portal';

var openCount = 0;
var windowIsUndefined = !(typeof window !== 'undefined' && window.document && window.document.createElement);

var IS_REACT_16 = 'createPortal' in ReactDOM;

var PortalWrapper = function (_React$Component) {
  _inherits(PortalWrapper, _React$Component);

  function PortalWrapper(props) {
    _classCallCheck(this, PortalWrapper);

    var _this = _possibleConstructorReturn(this, (PortalWrapper.__proto__ || Object.getPrototypeOf(PortalWrapper)).call(this, props));

    _this.getParent = function () {
      var getContainer = _this.props.getContainer;

      if (getContainer) {
        if (typeof getContainer === 'string') {
          return document.querySelectorAll(getContainer)[0];
        }
        if (typeof getContainer === 'function') {
          return getContainer();
        }
        if ((typeof getContainer === 'undefined' ? 'undefined' : _typeof(getContainer)) === 'object' && getContainer instanceof window.HTMLElement) {
          return getContainer;
        }
      }
      return document.body;
    };

    _this.getContainer = function () {
      if (windowIsUndefined) {
        return null;
      }
      if (!_this.container) {
        _this.container = document.createElement('div');
        var parent = _this.getParent();
        parent.appendChild(_this.container);
      }
      _this.setWrapperClassName();
      return _this.container;
    };

    _this.setWrapperClassName = function () {
      var wrapperClassName = _this.props.wrapperClassName;

      if (_this.container && wrapperClassName && wrapperClassName !== _this.container.className) {
        _this.container.className = wrapperClassName;
      }
    };

    _this.savePortal = function (c) {
      _this._component = c;
    };

    var visible = props.visible;

    openCount = visible ? openCount + 1 : openCount;
    _this.state = {};
    return _this;
  }

  _createClass(PortalWrapper, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.setWrapperClassName();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var visible = this.props.visible;

      this.container = null;
      this._component = null;
      // 离开时不会 render， 导到离开时数值不变，改用 func 。。
      openCount = visible && openCount ? openCount - 1 : openCount;
      if (!IS_REACT_16) {
        if (visible) {
          this.renderComponent({
            afterClose: this.removeContainer,
            onClose: function onClose() {},

            visible: false
          });
        } else {
          this.removeContainer();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          forceRender = _props.forceRender,
          visible = _props.visible;

      var portal = null;
      var childProps = {
        getOpenCount: function getOpenCount() {
          return openCount;
        },
        getContainer: this.getContainer
      };
      // suppport react15
      if (!IS_REACT_16) {
        return React.createElement(
          ContainerRender,
          {
            parent: this,
            visible: visible,
            autoDestroy: false,
            getComponent: function getComponent() {
              var extra = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              return children(_extends({}, extra, childProps));
            },
            getContainer: this.getContainer,
            forceRender: forceRender
          },
          function (_ref) {
            var renderComponent = _ref.renderComponent,
                removeContainer = _ref.removeContainer;

            _this2.renderComponent = renderComponent;
            _this2.removeContainer = removeContainer;
            return null;
          }
        );
      }
      if (forceRender || visible || this._component) {
        portal = React.createElement(
          Portal,
          { getContainer: this.getContainer, ref: this.savePortal },
          children(childProps)
        );
      }
      return portal;
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, _ref2) {
      var prevVisible = _ref2.visible;
      var visible = props.visible;

      if (prevVisible !== undefined && visible !== prevVisible) {
        openCount = visible && !prevVisible ? openCount + 1 : openCount - 1;
      }
      return {
        visible: visible
      };
    }
  }]);

  return PortalWrapper;
}(React.Component);

PortalWrapper.propTypes = {
  wrapperClassName: PropTypes.string,
  forceRender: PropTypes.bool,
  getContainer: PropTypes.any,
  children: PropTypes.func,
  visible: PropTypes.bool
};

export default polyfill(PortalWrapper);


//////////////////
// WEBPACK FOOTER
// ./~/rc-util/es/PortalWrapper.js
// module id = 660
// module chunks = 3